// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders a paper picker HTML radio select list
 */
M.View.ProductDetails.RadioPaperPicker = Backbone.View.extend({
  tagName: 'table',
  className: 'radioPaperPicker radioPicker',

  events: {
    'change': 'onChange'
  },

  /**
   * Initializes the RadioPaperPicker and binds to the model's 'priceUpdated'
   * event.
   */
  initialize: function() {
    var that = this;
    this.$el = $(this.el);
    this.model.bind('priceUpdated', function() {
      that.render();
    });
  },

  /**
   * Renders the HTML for the RadioPaperPicker with the pricing and options from
   * the model.
   */
  render: function() {
    var that = this;
    this.$el.empty();

    // only show radio buttons if there is more than 1 paper option.
    var shouldShowRadioButton = this.model.get('paperOptionList').length > 1;

    // For each paper/price diff pair, create an input html element for it and
    // add it to the view.
    this.model.eachPaperPricePair(function (paperKindId, priceDiff) {
      var paperKindName =
        M.Model.ProductDetails.PAPER_OPTION_LABELS[paperKindId];
      var labelText = paperKindName + ' Paper: +' + priceDiff;
      var isAvailablePaperOption = priceDiff !== null;

      var optionElem = that.createPaperOptionElem(
        paperKindId,
        paperKindName,
        priceDiff,
        shouldShowRadioButton,
        isAvailablePaperOption
      );
      that.$el.append(optionElem);
    });

    // Truncate long paper option descriptions in order to keep
    // the "personalize" button above the fold.
    this.$el.find('.caption').jTruncate({
      length: 15, lessText: 'less'
    });

    // Bind to the 'more'/'less' link created by jTruncate.
    // Note: We are using the class of the link to find the element since
    // jTruncate does not return a reference to it. Binding to .caption does not
    // work because the link intercepts the click.
    var $toggleLink = this.$el.find('.truncate_more_link');
    $toggleLink.click(function(e) {
      var $el = $(e.target);
      var desc = $el.parents('.description').find('label').text();
      var linkText = $el.text() === 'more' ? 'less' : 'more';
      var sku = that.model.get('productSku');
      that.triggerDescToggleTracking(linkText, desc, sku);
      that.trigger('moreButtonClicked');
    });

    return this;
  },

  /**
   * Logs tracking event when the user toggles the description
   * with the more|less link.
   *
   * Unfortunately, we can't append track API events using the declarative style
   * due to the jTruncate jQuery plugin handling the description text toggling
   */
  triggerDescToggleTracking: function(linkText, paperDesc, sku) {
    try {
      M.sendTrackAPI({
        'feature': M.GA.TRACK_EVENT_CATEGORY.PDP,
        'event': M.GA.TRACK_EVENT_ACTION.PRODUCT_OPTION_DESCRIPTION_TOGGLE,
        'option_type': 'paper',
        'option_value': encodeURIComponent(paperDesc),
        'sku': sku,
        'link_text': linkText
      });
    } catch (e) {
      console.log('Unable to log trackAPI event for paper description toggle');
    }
  },

  /**
   * Returns the HTML for a paper option input element.
   *
   * Arguments
   * paperKindId -- int, the id of the paper kind this input corresponds to.
   * labelElem -- string, html to be added to the option.
   */
  createPaperOptionElem: function(paperKindId, paperName, paperPriceDiff,
      shouldShowRadioButton, isAvailablePaperOption) {
    var tr = $('<tr>');

    if (shouldShowRadioButton) {
      var radioCol = $('<td>').addClass('input');

      // Note: IE requires you to create input DOM elements in one line:
      // http://stackoverflow.com/questions/6432246/
      // radio-buttons-and-attrchecked-checked-does-not-work-in-ie7
      var radioPaperEl = $("<input />", {
        type: 'radio',
        id: M.View.ProductDetails.PAPER_DOM_IDS[paperKindId],
        checked: false,
        value: paperKindId
      });
      if (paperKindId == this.model.get('paperKindId')) {
        radioPaperEl.attr('checked', true);
      }
      if (!isAvailablePaperOption) {
        radioCol.attr('disabled', true);
      }
      radioCol.append(radioPaperEl);
      tr.append(radioCol);
    }

    // create the description element
    var descriptionCol = $('<td>').addClass('description');
    var labelEl = $('<label>');
    labelEl.html(paperName);

    if (paperKindId == this.model.get('paperKindId')) {
      labelEl.addClass('checked');
    }

    labelEl.attr('for', M.View.ProductDetails.PAPER_DOM_IDS[paperKindId]);
    descriptionCol.append(labelEl);

    // create the caption element for the description element
    var captionHtml = M.View.ProductDetails.PAPER_CAPTIONS[paperKindId];
    if (captionHtml) {
      var captionEl = $('<span>');
      captionEl.addClass('caption');
      captionEl.html(captionHtml);
      descriptionCol.append('&nbsp;&nbsp;')
      descriptionCol.append(captionEl);
    }

    // For TripleThick kinds, display a postage warning.
    var isTripleThickSelected = (_.contains(TRIPLE_THICK_PAPER_KINDS, paperKindId)
        && paperKindId == this.model.get('paperKindId'));
    if (isTripleThickSelected &&
      !_.contains(M.View.ProductDetails.NO_POSTAGE_WARNING_PRODUCT_KINDS,
        this.model.getProductKind())) {
      var postageLink = $('<a>');
      postageLink.addClass('postage');
      postageLink.text('may require extra stamps');
      var that = this;
      postageLink.click(function() {
        that.trigger('postageDialogRequested', paperKindId);
      });
      descriptionCol.append('<br/>');
      descriptionCol.append(postageLink);
    }
    if (!isAvailablePaperOption) {
      descriptionCol.addClass('disabled');
    }
    tr.append(descriptionCol);

    if (isAvailablePaperOption) {
      var priceDeltaCol = $('<td>').addClass('priceDelta');
      var priceDiffElem = $('<span>')
        .attr('class', 'priceDiff');
      if (paperPriceDiff % 1) {
        paperPriceDiff = paperPriceDiff.toFixed(2);
      }
      if (paperPriceDiff !== null) {
        priceDiffElem.html('+&nbsp;$' + paperPriceDiff);
      }
      priceDeltaCol.append(priceDiffElem);
      tr.append(priceDeltaCol);
    }

    if (_.contains(TRIPLE_THICK_PAPER_KINDS, paperKindId) &&
        this.options.collapseTripleThick) {
      tr.hide();
    }
    return tr;
  },

  /**
   * Triggers a paperSelected event when the paper option is changed.
   */
  onChange: function(e) {
    var paperKindId = parseInt(e.target.value);
    this.trigger('paperSelected', paperKindId);
  }
});
